
import { Image as VantImage } from "react-vant";

export default function Img({ src, alt, type,defaultSrc,...props }) {
  return <VantImage src={src}   alt={alt} {...props} />;
}
